var components
try {
  components = {
    uParse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-parse/u-parse" */ "uview-ui/components/u-parse/u-parse.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.info ? _vm.commentList.length : null
  var l1 =
    _vm.info && !(g0 === 0)
      ? _vm.__map(_vm.commentList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = item.multifileList && item.multifileList.length > 0
          var g2 = _vm.$u.timeFormat(new Date(item.createDate).getTime())
          var l0 = _vm.__map(item.childern, function (child, a) {
            var $orig = _vm.__get_orig(child)
            var g3 = child.multifileList && child.multifileList.length > 0
            return {
              $orig: $orig,
              g3: g3,
            }
          })
          var g4 = item.childern.length
          return {
            $orig: $orig,
            g1: g1,
            g2: g2,
            l0: l0,
            g4: g4,
          }
        })
      : null
  var g5 = _vm.info ? _vm.multifileList.length : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show1 = true
    }
    _vm.e1 = function ($event) {
      _vm.show = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l1: l1,
        g5: g5,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }